// import api from './index'
import axios from '@/utils/request'
const urlloginPrefix = 'oauth'
/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param data
 * @returns {*}
 */
export function login (data) {
  return axios({
    url: urlloginPrefix + '/oauths/login',
    method: 'post',
    params: data
  })
}

export function getInfo () {
  return axios({
    url: urlloginPrefix + '/oauths/info',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout (token) {
  return axios({
    url: urlloginPrefix + '/oauths/loginOut',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'token': token
    }
  })
}

/**
 * 登录用户重置密码
 * @param {*} data
 * @returns
 */
export function resetPassword (data) {
  return axios({
    url: urlloginPrefix + '/userDetails/reset/password',
    method: 'put',
    data
  })
}
/**
 * 忘记密码
 * @param {*} data
 * @returns
 */
export function forgetPassword (data) {
  return axios({
    url: urlloginPrefix + '/userDetails/forget/rePassword',
    method: 'put',
    data
  })
}

/**
 * 平台注册
 * @param {*} data
 * @returns
 */
export function register (data) {
  return axios({
    url: urlloginPrefix + '/userDetails/register',
    method: 'post',
    data
  })
}
// 重置手机号
export function resetPhone (data) {
  return axios({
    url: urlloginPrefix + '/userDetails/update/mobilePhone',
    method: 'post',
    data
  })
}
// 重置用户信息
export function resetInfo (data) {
  return axios({
    url: urlloginPrefix + '/userDetails/update/self/info',
    method: 'put',
    data
  })
}

// 获取登录二维码
export function getQrcode () {
  return axios.get(`${urlloginPrefix}/userDetails/qrcode?grant_type=shine_login`)
}
// 获取绑定二维码
export function getBindQrcode (data) {
  return axios.get(`${urlloginPrefix}/userDetails/bind/qrcode?change=${data}`)
}
// 查询 登录/绑定 状态
export function loginState (data) {
  return axios.get(`${urlloginPrefix}/userDetails/qrcode/info?noncestr=${data}`)
}
// 查询账号是否注册
export function isExist (data) {
  return axios.get(`${urlloginPrefix}/userDetails/exist?phone=${data}`)
}
/**
 * 获取短信验证码
 * @param {*} parameter
 * @returns
 */
export function getSmsCaptcha (data) {
  return axios({
    url: `/platform/publics/message/${data.type}/code`,
    method: 'post',
    data
  })
}
/**
 * 绑定
 * @param {*} data
 * @returns
 */
export function bind (data) {
  return axios({
    url: `${urlloginPrefix}/userDetails/bind`,
    method: 'post',
    data
  })
}
